import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import OtherDeductionPresenter from "./OtherDeductionPresenter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import Search from "../../../components/Search";

class OtherDeductionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      objects: [],
      selected: [],
      limit: 10,
      current: 1,
      count: 0,
    };
    this.presenter = new OtherDeductionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "other_deductions";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async handleAddDeduction() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute("other_deductions", id);
    this.refetchData();
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async generateCSV() {
    await this.presenter.getGenerateCSV();
  }

  render() {
    const { objects, loading, selected, count, limit, current } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "payrollTypes" &&
        fields !== "employmentTypes" &&
        fields !== "payItems" &&
        fields !== "deductionTypes"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Rererence Table {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <Button onClick={this.handleAddDeduction.bind(this)}>
                        <i className="bi bi-plus-lg" /> Create {schema.label}
                      </Button>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={this.generateCSV.bind(this)}
                      >
                        Export CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                editId={this.handleEditData.bind(this)}
                objectId={(id) => this.presenter.handleDeleteData(id)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                selectable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(OtherDeductionPage);
